import { FormGroup } from '@ksyos/design-system';
import { styled } from 'styled-components';

export const StyledFormGroup = styled(FormGroup)`
    & > div {
        max-width: 100%;
    }
    & > label {
        margin: 0;
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 16px;
    }
`;
